/**
 * An enumeration of constants with their feature flag keys.
 */
export enum Flag {
  LD_PROGRESSIVE_DISCLOSURE = 'login-grw-10511-progressive-disclosure-url',
  LD_EMEA_DATA_BANNER_VISIBLE = 'emea_data_banner_visible',
  LD_USE_FRAUD_PLATFORM_SERVICE = 'login-use-fraud-platform-service',
  LD_MAINTENANCE_FLAG = 'login_maintenance_flag',
  LD_SIGNUP_WIDGET = 'zil-grw-15531-signup-widget',
  LD_MCP_CONNECTOR_SIGNUP_FLOW = 'zil-grw-16096-mcp-builder-signup-flow',
  LD_EMAIL_BUILDER_SIGNUP = 'zil-grw-16096-email-builder-signup',
}
